import { Form as AntdForm, ConfigProvider, type FormItemProps } from 'antd'
import type { CSSProperties } from 'react'
import styled from 'styled-components'
import { formTheme } from '../../config/form-theme'

interface StyledFormItemProps {
  short?: boolean
  long?: boolean
  full?: boolean
  emptyLabel?: boolean
}

const SHORT_WIDTH = 160
const LONG_WIDTH = 400

const calculateLabelColStyle = (props: FormItemProps & StyledFormItemProps) => {
  let baseStyle = { ...labelColStyle }

  if (props.short) {
    baseStyle = { ...baseStyle, width: SHORT_WIDTH }
  } else if (props.long) {
    baseStyle = { ...baseStyle, width: LONG_WIDTH }
  }

  if (props.emptyLabel) {
    baseStyle = { ...baseStyle, ...emptyLabelStyle }
  }

  return baseStyle
}

export const FormItem = (props: FormItemProps & StyledFormItemProps) => (
  <ConfigProvider theme={formTheme}>
    <StyledFormItem
      labelAlign="left"
      labelCol={{
        style: calculateLabelColStyle(props)
      }}
      {...props}
    />
  </ConfigProvider>
)

export const labelColStyle: CSSProperties = {
  width: 200,
  overflowWrap: 'break-word',
  whiteSpace: 'normal',
  overflow: 'visible'
}

const emptyLabelStyle: CSSProperties = {
  opacity: 0
}

const StyledFormItem = styled(AntdForm.Item)<{
  $last?: boolean
  full?: boolean
}>`
  ${(props) => (props.full ? 'width: 100%;' : 'max-width: 580px;')}
  overflow: visible;

  .ant-form-item-label > label {
    display: inline !important;
  }

  .ant-form-item-control {
    margin-bottom: 0 !important;
  }

  flex: 1;
`
